import { createContext, useContext } from 'react';

/** 他人已处理本环节时锁定物流/收款等操作按钮 */
export const OrderCollaborationLockContext = createContext(false);

export const useOrderCollaborationLock = () => useContext(OrderCollaborationLockContext);
